module.exports = __webpack_public_path__ + "static/media/home-video-placeholder.a0b8a122.jpg";